import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HomeState } from './home.reducer';

export const selectHomeState = createFeatureSelector<HomeState>('home');

export const selectUploadedFiles = createSelector(
  selectHomeState,
  (state: HomeState) => state.uploadedFiles,
);

export const selectGerberFiles = createSelector(
  selectHomeState,
  (state: HomeState) => state.gerberFiles,
);

export const selectLectraFiles = createSelector(
  selectHomeState,
  (state: HomeState) => state.lectraFiles,
);

export const selectConvertedFiles = createSelector(
  selectHomeState,
  (state: HomeState) => state.convertedFiles,
);

export const selectIsFileBoxBlocked = createSelector(
  selectHomeState,
  (state: HomeState) => state.fileBoxLocked,
);

export const selectIsGerberLocked = createSelector(
  selectHomeState,
  (state: HomeState) => state.gerberLocked,
);

export const selectIsLectraLocked = createSelector(
  selectHomeState,
  (state: HomeState) => state.lectraLocked,
);

export const selectMonthlyConvertedFiles = createSelector(
  selectHomeState,
  (state: HomeState) => state.monthlyConvertedFiles,
);
